import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import { RUNTIMES } from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';


export default class DigitalLineSetNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Digital Line Set';
        this.id = 'node_digital_line_set';
        this.icon = 'VscDebugConsole';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Set',
                portId: 'digital_line_set',
                params: [],
            },
        ];

        this.settings = this.settings.concat([
            {
                id: 'LINE_NUMBER',
                name: 'Line Number',
                settingType: SettingType.STRINGVARIABLE,
                default: '',
                required: true,
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.OPTION,
                options: [
                    {
                        value: '1',
                        name: 'HIGH',
                    },
                    {
                        value: '0',
                        name: 'LOW',
                    },
                ],
                default: '0',
                required: true,
            },
        ]);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const LINE_NUMBER = this.getSettingValue('LINE_NUMBER');
            const VALUE = this.getSettingValueOptionName('VALUE');
            return `Set line ${LINE_NUMBER} to ${VALUE}`;
        }
        return super.getSettingValue(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case RUNTIMES.ZEPHYR:
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### Digital Line Set
Sets digital line high or low.

**Line Number** - The line number to set.

**Value** - The value to set the line to.`;
    }
}
